export const meta = {
  title: 'Scaling Laws for Human Motion Generation',
  summary:
    'Scaling laws for human motion generation.',
  author: 'Cartwheel Team',
  category: 'idea',
  date: '2026-08-24',
  hero: {
    type: 'image',
    cdnKey: 'fig1_isoflop.png',
  },
  slug: 'scaling-laws',
};

<ArticleImage cdnKey="fig1_isoflop.png" />

Human Motion Generation has historically been niche and difficult to scale. Animators, roboticists, motion analysts, game developers, and more see the potential
in the technology, but it rarely lives up to the rigor required in production. 

At Cartwheel, we have long believed this is because all prior systems have been fantastically data-constrained. But until today, we haven't been able to prove that scaling would actually help model performance.

Today, we present our flagship research paper

> Compute-Optimal Scaling Laws for Human Motion Generation

<ScalingLawsCTA />

We are building the world's largest, high-quality human-motion dataset. We train hundreds of models across varying scales. We then show that they match Chinchilla scaling found in language.

This is an exciting breakthrough as it places motion as the fifth data modality that we understand how to scale!  

While text, images, audio, and video all have scaling laws—which we discuss in the paper—none of them really reflect the physical world.
3D human motion, across time, is a better reflection of the physical world than any of them. 

And now that we know it scales, we are poised to see a revolution in physical AI for robotics alongside digital AI for entertainment.

By building purpose-built infrastructure for sourcing, capturing, and structuring human motion data, we can show that both autoregressive and flow matching motion models scale predictably.

This means we can predict, before training a model, how good it will be. It reduces the risk of big training runs (which we've kicked off now!) and shows that the model quality gets better and better, which makes it more useful to end users.

Motion is no longer data-constrained; it is now a predictable and scalable frontier for physical and digital intelligence. With our largest models training, the gap between generated motion and the real physical world is closing fast.


<ScalingLawsCTA />
